import { render, staticRenderFns } from "./CategoriesListV2.vue?vue&type=template&id=1c96266e&scoped=true"
import script from "./CategoriesListV2.vue?vue&type=script&lang=js"
export * from "./CategoriesListV2.vue?vue&type=script&lang=js"
import style0 from "./CategoriesListV2.vue?vue&type=style&index=0&id=1c96266e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c96266e",
  null
  
)

export default component.exports